// import React, { useState } from "react";

// const PackageSuggestion = ({ 
//   data, 
//   handlePackageSuggestedClick,
//   clientPackages
// }) => {
//   const [hoveredSuggestion, setHoveredSuggestion] = useState(null);

//   const isPackageActive = (packageId) => {
//     const currentDate = new Date();
//     return clientPackages.some(pkg => {
//       // Check if package ID matches
//       if (pkg.packageId !== packageId) return false;
      
//       // Check if validity date is in future
//       const validityDate = new Date(pkg.validity);
//       if (validityDate < currentDate) return false;
      
//       // Check if package has services with count > 0
//       return pkg.services?.length > 0;
//     });
//   };

//   const handleChange = (pkg, e) => {
//     if (isPackageActive(pkg._id)) {
//       // Don't proceed if package is active
//       e.preventDefault();
//       e.stopPropagation();
//       return;
//     }
//     handlePackageSuggestedClick(pkg);
//   };

//   // Group packages by category if available, otherwise just show all
//   const groupedPackages = data.reduce((acc, pkg) => {
//     const category = pkg.category || 'General';
//     if (!acc[category]) {
//       acc[category] = [];
//     }
//     acc[category].push(pkg);
//     return acc;
//   }, {});

//   const containerStyle = {
//     position: "absolute",
//     backgroundColor: "#fff",
//     border: "1px solid #ccc",
//     zIndex: 1000,
//     maxHeight: "300px",
//     overflowY: "auto",
//     boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
//     width: "260px",
//     padding: "10px",
//     borderRadius: "5px",
//   };

//   const categoryStyle = {
//     fontWeight: "bold",
//     padding: "8px 5px",
//     backgroundColor: "#f8f8f8",
//     borderBottom: "1px solid #ddd",
//   };

//   const itemStyle = {
//     display: "flex",
//     justifyContent: "space-between",
//     padding: "8px",
//     cursor: "pointer",
//     borderBottom: "1px solid #eee",
//     flexDirection: "column",
//   };

//   const itemContentStyle = {
//     display: "flex",
//     justifyContent: "space-between",
//     width: "100%",
//   };

//   const detailsStyle = {
//     display: "flex",
//     flexDirection: "column",
//     alignItems: "flex-end",
//     fontSize: "0.9em",
//   };

//   const servicesCountStyle = {
//     fontSize: "0.8em",
//     color: "#666",
//   };

//   const errorStyle = {
//     fontSize: "0.7em",
//     color: "red",
//     marginTop: "4px",
//     fontStyle: "italic",
//   };

//   return (
//     <div style={containerStyle}>
//       {Object.entries(groupedPackages).map(([category, packages]) => (
//         <div key={category}>
//           <div style={categoryStyle}>{category}</div>
//           {packages.map((pkg) => {
//             const isActive = isPackageActive(pkg._id);
//             return (
//               <div
//                 key={pkg._id}
//                 onClick={(e) => handleChange(pkg, e)}
//                 style={{
//                   ...itemStyle,
//                   backgroundColor: hoveredSuggestion === pkg._id ? "#6174DD" : "white",
//                   color: hoveredSuggestion === pkg._id ? "white" : "black",
//                   opacity: isActive ? 0.7 : 1,
//                   cursor: isActive ? "not-allowed" : "pointer",
//                 }}
//                 onMouseEnter={() => !isActive && setHoveredSuggestion(pkg._id)}
//                 onMouseLeave={() => setHoveredSuggestion(null)}
//               >
//                 <div style={itemContentStyle}>
//                   <span>{pkg.packageName}</span>
//                   <div style={detailsStyle}>
//                     <span>₹{pkg.price}</span>
//                     {pkg.services && (
//                       <span style={{ 
//                         ...servicesCountStyle,
//                         color: hoveredSuggestion === pkg._id ? "#eee" : "#666" 
//                       }}>
//                         {pkg.services.length} services
//                       </span>
//                     )}
//                   </div>
//                 </div>
//                 {isActive && (
//                   <div style={{
//                     ...errorStyle,
//                     color: hoveredSuggestion === pkg._id ? "#ffcccc" : "red"
//                   }}>
//                     This package already exists and is active
//                   </div>
//                 )}
//               </div>
//             );
//           })}
//         </div>
//       ))}
//     </div>
//   );
// };

// export default PackageSuggestion;

import React, { useState, useEffect, useRef } from "react";

const PackageSuggestion = ({ 
  data, 
  handlePackageSuggestedClick,
  clientPackages,
  inputRef,
  setPackageSuggested,
  focusedIndex
}) => {
  const [hoveredSuggestion, setHoveredSuggestion] = useState(null);
  const [selectedIndex, setSelectedIndex] = useState(-1);
  const suggestionsRef = useRef(null);
  const itemRefs = useRef([]);

  const isPackageActive = (packageId) => {
    const currentDate = new Date();
    return clientPackages.some(pkg => {
      if (pkg.packageId !== packageId) return false;

      const validityDate = new Date(pkg.validity);
      if (validityDate < currentDate) return false;

      return pkg.services?.length > 0;
    });
  };

  const handleChange = (pkg, e) => {
    if (isPackageActive(pkg._id)) {
      e.preventDefault();
      e.stopPropagation();
      return;
    }
    handlePackageSuggestedClick(pkg);
  };

  // Handle keyboard navigation
  useEffect(() => {
    const target = inputRef;
    if (!target) return;

    const handleKeyDown = (e) => {
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        const topPackages = data.filter(pkg => pkg.isTopPackage);
        const otherPackages = data.filter(pkg => pkg.membershipType === "packageType");
        const totalItems = topPackages.length + otherPackages.length;
        
        setSelectedIndex(prev => (prev >= totalItems - 1 ? 0 : prev + 1));
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        const topPackages = data.filter(pkg => pkg.isTopPackage);
        const otherPackages = data.filter(pkg => pkg.membershipType === "packageType");
        const totalItems = topPackages.length + otherPackages.length;
        
        setSelectedIndex(prev => (prev <= 0 ? totalItems - 1 : prev - 1));
      } else if (e.key === 'Enter' && selectedIndex >= 0) {
        e.preventDefault();
        
        const topPackages = data.filter(pkg => pkg.isTopPackage);
        const otherPackages = data.filter(pkg => pkg.membershipType === "packageType");
        
        let selectedPackage;
        if (selectedIndex < topPackages.length) {
          selectedPackage = topPackages[selectedIndex];
        } else {
          selectedPackage = otherPackages[selectedIndex - topPackages.length];
        }
        
        if (!isPackageActive(selectedPackage._id)) {
          handlePackageSuggestedClick(selectedPackage);
        }
      } else if (e.key === 'Escape') {
        setPackageSuggested([]);
        setSelectedIndex(-1);
        target.blur();
      }
    };

    target.addEventListener('keydown', handleKeyDown);
    return () => target.removeEventListener('keydown', handleKeyDown);
  }, [data, selectedIndex, inputRef, handlePackageSuggestedClick, setPackageSuggested]);

  // Reset index when data changes
  useEffect(() => {
    setSelectedIndex(-1);
    const topPackages = data.filter(pkg => pkg.isTopPackage);
    const otherPackages = data.filter(pkg => pkg.membershipType === "packageType");
    itemRefs.current = itemRefs.current.slice(0, topPackages.length + otherPackages.length);
  }, [data]);

  // Scroll selected item into view
  useEffect(() => {
    if (selectedIndex >= 0 && itemRefs.current[selectedIndex]) {
      itemRefs.current[selectedIndex].scrollIntoView({
        behavior: 'smooth',
        block: 'nearest'
      });
    }
  }, [selectedIndex]);

  const containerStyle = {
    position: "absolute",
    backgroundColor: "#fff",
    border: "1px solid #ccc",
    zIndex: 1000,
    maxHeight: "300px",
    overflowY: "auto",
    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
    width: "260px",
    padding: "10px",
    borderRadius: "5px",
  };

  const categoryStyle = {
    fontWeight: "bold",
    padding: "8px 5px",
    backgroundColor: "#f8f8f8",
    borderBottom: "1px solid #ddd",
  };

  const itemStyle = {
    display: "flex",
    justifyContent: "space-between",
    padding: "8px",
    cursor: "pointer",
    borderBottom: "1px solid #eee",
    flexDirection: "column",
  };

  const itemContentStyle = {
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
  };

  const detailsStyle = {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end",
    fontSize: "0.9em",
  };

  const servicesCountStyle = {
    fontSize: "0.8em",
    color: "#666",
  };

  const errorStyle = {
    fontSize: "0.7em",
    color: "red",
    marginTop: "4px",
    fontStyle: "italic",
  };

  // ✅ Segregate Top 5 & Other Packages from data
  const topPackages = data.filter(pkg => pkg.isTopPackage);
  const otherPackages = data.filter(pkg => pkg.membershipType === "packageType");

  // Track the current index for rendering
  let currentIndex = 0;

  return (
    <div style={containerStyle} ref={suggestionsRef}>
      {topPackages.length > 0 && (
        <div>
          <div style={categoryStyle}>Frequently Used</div>
          {topPackages.map(pkg => {
            const isActive = isPackageActive(pkg._id);
            const index = currentIndex++;
            
            return (
              <div
                key={pkg._id}
                ref={el => itemRefs.current[index] = el}
                onClick={(e) => handleChange(pkg, e)}
                style={{
                  ...itemStyle,
                  backgroundColor: selectedIndex === index || hoveredSuggestion === pkg._id ? "#6174DD" : "white",
                  color: selectedIndex === index || hoveredSuggestion === pkg._id ? "white" : "black",
                  opacity: isActive ? 0.7 : 1,
                  cursor: isActive ? "not-allowed" : "pointer",
                }}
                onMouseEnter={() => !isActive && setHoveredSuggestion(pkg._id)}
                onMouseLeave={() => setHoveredSuggestion(null)}
              >
                <div style={itemContentStyle}>
                  <span>{pkg.packageName}</span>
                  <div style={detailsStyle}>
                    <span>₹{pkg.price}</span>
                    {pkg.services && (
                      <span style={{
                        ...servicesCountStyle,
                        color: selectedIndex === index || hoveredSuggestion === pkg._id ? "#eee" : "#666"
                      }}>
                        {pkg.services.length} services
                      </span>
                    )}
                  </div>
                </div>
                {isActive && (
                  <div style={{
                    ...errorStyle,
                    color: selectedIndex === index || hoveredSuggestion === pkg._id ? "#ffcccc" : "red"
                  }}>
                    This package already exists and is active
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}

      {otherPackages.length > 0 && (
        <div>
          <div style={categoryStyle}>Other Packages</div>
          {otherPackages.map(pkg => {
            const isActive = isPackageActive(pkg._id);
            const index = currentIndex++;
            
            return (
              <div
                key={pkg._id}
                ref={el => itemRefs.current[index] = el}
                onClick={(e) => handleChange(pkg, e)}
                style={{
                  ...itemStyle,
                  backgroundColor: selectedIndex === index || hoveredSuggestion === pkg._id ? "#6174DD" : "white",
                  color: selectedIndex === index || hoveredSuggestion === pkg._id ? "white" : "black",
                  opacity: isActive ? 0.7 : 1,
                  cursor: isActive ? "not-allowed" : "pointer",
                }}
                onMouseEnter={() => !isActive && setHoveredSuggestion(pkg._id)}
                onMouseLeave={() => setHoveredSuggestion(null)}
              >
                <div style={itemContentStyle}>
                  <span>{pkg.packageName}</span>
                  <div style={detailsStyle}>
                    <span>₹{pkg.price}</span>
                    {pkg.services && (
                      <span style={{
                        ...servicesCountStyle,
                        color: selectedIndex === index || hoveredSuggestion === pkg._id ? "#eee" : "#666"
                      }}>
                        {pkg.services.length} services
                      </span>
                    )}
                  </div>
                </div>
                {isActive && (
                  <div style={{
                    ...errorStyle,
                    color: selectedIndex === index || hoveredSuggestion === pkg._id ? "#ffcccc" : "red"
                  }}>
                    This package already exists and is active
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default PackageSuggestion;